import * as React from "react";
import { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgFilter = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 32" width="1em" height="1em" aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" d="M31.907 1.808a.97.97 0 0 0-.877-.556H.97a.97.97 0 0 0-.748 1.587l11.555 14.015v12.924a.97.97 0 0 0 1.4.869l6.493-3.218a.969.969 0 0 0 .539-.868l.013-9.706L31.778 2.839a.97.97 0 0 0 .13-1.03zm-13.403 14.08a.969.969 0 0 0-.22.616l-.014 9.454-4.553 2.257v-11.71a.97.97 0 0 0-.222-.616L3.026 3.192h25.948z" /></svg>;
export default SvgFilter;